module.exports = __webpack_public_path__ + "img/N234-2-EN.6b5d1313.png";